import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=98c4eae8&scoped=true&"
import script from "./TransferModal.vue?vue&type=script&lang=js&"
export * from "./TransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c4eae8",
  null
  
)

export default component.exports